import { render, staticRenderFns } from "./recoveryPasswordPage.vue?vue&type=template&id=61b9d5f4&scoped=true"
import script from "./recoveryPasswordPage.vue?vue&type=script&lang=js"
export * from "./recoveryPasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b9d5f4",
  null
  
)

export default component.exports